import { render } from "./ButtonLoading.vue?vue&type=template&id=7f6c8182"
import script from "./ButtonLoading.vue?vue&type=script&lang=js"
export * from "./ButtonLoading.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/projects/panel.doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__